export const CRAWLING_NEWS_LIST_REQUEST = "CRAWLING_NEWS_LIST_REQUEST";
export const CRAWLING_NEWS_LIST_SUCCESS = "CRAWLING_NEWS_LIST_SUCCESS";
export const CRAWLING_NEWS_LIST_FAIL = "CRAWLING_NEWS_LIST_FAIL";
